// SEO configuration for all pages
export const seoConfig = {
  home: {
    title: 'Composable Enterprise Automation Platform',
    description: 'Transform your business with Aquargin\'s composable enterprise automation platform. Build modular, API-first business capabilities with no-code tools. 30% faster innovation through packaged business capabilities.',
    keywords: 'no-code platform, enterprise automation, business process automation, API-first platform, composable architecture, workflow automation, AI automation, business intelligence',
    image: '/images/A_modern_corporate_office_environment_with_a_confi_1750595349.png',
    url: '/'
  },
  about: {
    title: 'About Us - Your Composable Enterprise Architecture Partner',
    description: 'Learn about Aquargin\'s mission to enable composable business architecture through modular, API-first platforms. Trusted by Fortune 500 companies with 1000+ automation projects.',
    keywords: 'about aquargin, enterprise architecture, composable business, API-first platform, business automation company, digital transformation',
    image: '/images/Modern_conference_room_with_diverse_professional_t_1750596126.png',
    url: '/about'
  },
  products: {
    title: 'Enterprise Products - Healthcare, Finance, Business Intelligence',
    description: 'Explore Aquargin\'s comprehensive product suite: AquaCare (healthcare), AquaInvoice (finance), AquaBizz (business intelligence), AquaLearn (education), and AquaStyle (creative).',
    keywords: 'enterprise products, healthcare management, financial software, business intelligence, learning management system, creative project management',
    image: '/images/Executive_boardroom_with_large_wall_displays_showi_1750595962.png',
    url: '/products'
  },
  pricing: {
    title: 'Pricing Plans - Scale Smart with Volume Discounts',
    description: 'Flexible license-based pricing starting at $85/user/month. Volume discounts available. 30-day free trial. Enterprise features for 51+ licenses. No setup fees.',
    keywords: 'pricing plans, enterprise pricing, license pricing, volume discounts, free trial, enterprise software pricing',
    image: '/images/Professional_business_meeting_with_client_represen_1750596292.png',
    url: '/pricing'
  },
  features: {
    title: 'Platform Features - AI, Data Management, Workflow Automation',
    description: 'Discover Aquargin\'s powerful features: AI & Intelligence, Data Management, Reporting & Analytics, Workflow Automation, Visual Development, and Enterprise Security.',
    keywords: 'platform features, AI automation, data management, workflow automation, business intelligence, visual development, enterprise security',
    image: '/images/LEGO-like_building_blocks_floating_in_space_conne_1750595831.png',
    url: '/features'
  },
  'features/ai-intelligence': {
    title: 'AI & Intelligence - Conversational Business Intelligence',
    description: 'Transform data access with conversational AI. Natural language queries, smart analytics, autonomous operations, and AI-powered insights for better business decisions.',
    keywords: 'conversational AI, business intelligence, natural language queries, smart analytics, autonomous operations, AI insights',
    image: '/images/Abstract_3D_visualization_of_AI_brain_made_of_inte_1750595474.png',
    url: '/features/ai-intelligence'
  },
  'features/data-management': {
    title: 'Data Management - Complete Lifecycle Management',
    description: 'Comprehensive data management with CRUD operations, advanced relationships, metadata management, and 50+ field types. 99.99% data integrity guaranteed.',
    keywords: 'data management, CRUD operations, database management, data relationships, metadata management, data integrity',
    image: '/images/3D_isometric_view_of_structured_data_cubes_floatin_1750595537.png',
    url: '/features/data-management'
  },
  'features/workflow-automation': {
    title: 'Workflow Automation - Intelligent Process Automation',
    description: 'Automate business processes with drag-and-drop workflow designer. 75% time savings, 90% error reduction. Custom functions, scheduled jobs, and smart triggers.',
    keywords: 'workflow automation, business process automation, scheduled jobs, custom functions, process optimization',
    image: '/images/Visual_workflow_builder_with_drag-and-drop_interfa_1750595634.png',
    url: '/features/workflow-automation'
  },
  'features/reporting-analytics': {
    title: 'Reporting & Analytics - Interactive Dashboards',
    description: 'Create custom reports and interactive dashboards. Real-time data updates, advanced filtering, and seamless data export capabilities.',
    keywords: 'reporting, analytics, dashboards, business intelligence, data visualization, custom reports',
    image: '/images/Large_wall-mounted_display_showing_real-time_analy_1750595506.png',
    url: '/features/reporting-analytics'
  },
  'features/security-collaboration': {
    title: 'Security & Collaboration - Enterprise-Grade Protection',
    description: 'Bank-grade security with SOC 2, GDPR, HIPAA compliance. Role-based access control, end-to-end encryption, and comprehensive audit trails.',
    keywords: 'enterprise security, GDPR compliance, HIPAA compliance, role-based access, encryption, audit trails',
    image: '/images/Crystalline_security_shields_surrounding_and_prote_1750595731.png',
    url: '/features/security-collaboration'
  },
  'technical-architecture': {
    title: 'Technical Architecture - Enterprise-Grade Infrastructure',
    description: 'Explore Aquargin\'s robust platform architecture: microservices design, cloud-native infrastructure, API-first approach, and enterprise-grade security.',
    keywords: 'technical architecture, microservices, cloud-native, API-first, enterprise infrastructure, system architecture',
    image: '/images/Network_diagram_showing_Aquargin_platform_at_cente_1750596522.png',
    url: '/technical-architecture'
  },
  documentation: {
    title: 'Platform Documentation - Complete Developer Guide',
    description: 'Comprehensive documentation for Aquargin platform. API references, implementation guides, best practices, and technical specifications.',
    keywords: 'platform documentation, API documentation, developer guide, technical documentation, implementation guide',
    image: '/images/Clean_modern_API_documentation_interface_showing_c_1750596225.png',
    url: '/documentation'
  },
  contact: {
    title: 'Contact Us - Get Started with Aquargin',
    description: 'Contact Aquargin for demos, custom solutions, or support. 24/7 global support available. Phone: +91 70175 92307, Email: support@aquargin.com',
    keywords: 'contact aquargin, demo booking, customer support, enterprise solutions, consultation',
    image: '/images/Modern_customer_service_center_with_support_repres_1750596157.png',
    url: '/contact'
  },
  terms: {
    title: 'Terms & Conditions - Service Agreement',
    description: 'Read Aquargin\'s terms of service covering platform usage, licensing, data security, intellectual property, and service availability.',
    keywords: 'terms of service, service agreement, platform terms, licensing terms',
    url: '/terms',
    noindex: false
  },
  privacy: {
    title: 'Privacy Policy - Data Protection & GDPR Compliance',
    description: 'Aquargin\'s comprehensive privacy policy. GDPR compliant data protection, enterprise security standards, and user privacy rights.',
    keywords: 'privacy policy, GDPR compliance, data protection, privacy rights, enterprise security',
    url: '/privacy',
    noindex: false
  },
  disclaimer: {
    title: 'Disclaimer - Legal Information',
    description: 'Important legal disclaimer and limitations regarding the use of Aquargin platform and services.',
    keywords: 'disclaimer, legal information, terms and conditions',
    url: '/disclaimer',
    noindex: true
  },
  // Product-specific pages
  'products/aquacare': {
    title: 'AquaCare - Healthcare Management Excellence',
    description: 'Comprehensive healthcare automation platform. Patient management, EHR, appointment scheduling, HIPAA compliance. 75% faster processing, 95% satisfaction.',
    keywords: 'healthcare management, patient management, EHR, electronic health records, HIPAA compliance, medical software',
    image: '/images/Modern_hospital_setting_with_healthcare_profession_1750595898.png',
    url: '/products/aquacare'
  },
  'products/aquainvoice': {
    title: 'AquaInvoice - Financial Operations Platform',
    description: 'Advanced financial management and inventory control. Automated invoicing, real-time inventory, multi-currency support. 80% faster processing.',
    keywords: 'financial management, invoice automation, inventory management, accounting software, financial reporting',
    image: '/images/Professional_accountant_working_with_automated_inv_1750595930.png',
    url: '/products/aquainvoice'
  },
  'products/aquabizz': {
    title: 'AquaBizz - Enterprise Business Intelligence',
    description: 'Complete business management platform. Advanced analytics, performance dashboards, workflow management. 300% ROI within 12 months.',
    keywords: 'business intelligence, enterprise management, analytics platform, performance dashboards, business automation',
    image: '/images/Executive_boardroom_with_large_wall_displays_showi_1750595962.png',
    url: '/products/aquabizz'
  },
  'products/aqualear n': {
    title: 'AquaLearn - Learning Management System',
    description: 'Educational platform for corporate training and academic institutions. Course management, virtual classrooms, 92% completion rate.',
    keywords: 'learning management system, corporate training, e-learning platform, course management, virtual classroom',
    image: '/images/Modern_classroom_or_training_facility_with_digital_1750595993.png',
    url: '/products/aqualear n'
  },
  'products/aquastyle': {
    title: 'AquaStyle - Creative Project Management',
    description: 'Specialized platform for creative agencies and design studios. Project portfolio management, creative asset management, 40% faster delivery.',
    keywords: 'creative project management, design studio software, creative asset management, agency management',
    image: '/images/Design_studio_environment_with_creative_profession_1750596025.png',
    url: '/products/aquastyle'
  },
  // Custom solution pages
  'solutions/aquacrm': {
    title: 'AquaCRM - Enterprise Customer Relationship Management',
    description: 'Comprehensive CRM with 360° customer view, sales pipeline management, marketing automation, and AI-powered lead scoring.',
    keywords: 'CRM software, customer relationship management, sales pipeline, marketing automation, lead scoring',
    url: '/solutions/aquacrm'
  },
  'solutions/aquahr': {
    title: 'AquaHR - Human Resources Management System',
    description: 'Complete HR management with talent acquisition, performance tracking, payroll integration, and compliance management.',
    keywords: 'HR software, human resources management, talent management, payroll system, HR compliance',
    url: '/solutions/aquahr'
  },
  'solutions/aquainventory': {
    title: 'AquaInventory - Supply Chain Management',
    description: 'Advanced inventory and supply chain management with real-time tracking, demand forecasting, and supplier management.',
    keywords: 'inventory management, supply chain management, demand forecasting, warehouse management',
    url: '/solutions/aquainventory'
  },
  'solutions/aquamarketing': {
    title: 'AquaMarketing - Marketing Automation Platform',
    description: 'Comprehensive marketing automation with campaign management, lead scoring, social media integration, and ROI analytics.',
    keywords: 'marketing automation, campaign management, lead scoring, social media marketing, marketing ROI',
    url: '/solutions/aquamarketing'
  },
  'solutions/aquaproject': {
    title: 'AquaProject - Enterprise Project Management',
    description: 'Project management platform with resource planning, Gantt charts, team collaboration, and budget management.',
    keywords: 'project management software, resource planning, team collaboration, project tracking',
    url: '/solutions/aquaproject'
  }
};

// Function to get SEO data for a specific page
export const getSEOData = (path) => {
  // Remove leading slash and query parameters
  const cleanPath = path.replace(/^\//, '').split('?')[0];
  
  // Try exact match first
  if (seoConfig[cleanPath]) {
    return seoConfig[cleanPath];
  }
  
  // Try to match dynamic routes
  if (cleanPath.startsWith('products/')) {
    const productName = cleanPath.replace('products/', '');
    const productKey = `products/${productName.toLowerCase()}`;
    return seoConfig[productKey] || seoConfig.products;
  }
  
  if (cleanPath.startsWith('solutions/')) {
    const solutionName = cleanPath.replace('solutions/', '');
    const solutionKey = `solutions/${solutionName.toLowerCase()}`;
    return seoConfig[solutionKey] || seoConfig.products;
  }
  
  // Default fallback
  return seoConfig.home;
};

// Common keywords used across the site
export const commonKeywords = [
  'no-code platform',
  'enterprise automation',
  'business process automation',
  'API-first platform',
  'composable architecture',
  'workflow automation',
  'business intelligence',
  'enterprise software',
  'digital transformation',
  'cloud platform'
];

// Site-wide SEO constants
export const siteConfig = {
  siteName: 'Aquargin',
  siteUrl: 'https://aquargin.com',
  defaultTitle: 'Aquargin - Transform Your Ideas into Reality | No-Code Platform',
  defaultDescription: 'Transform Your Ideas into Reality with Aquargin\'s composable enterprise automation platform. Build modular, API-first business capabilities with no-code tools.',
  defaultImage: '/images/og-image.png',
  twitterHandle: '@aquargin',
  facebookAppId: '', // Add if you have Facebook app
  linkedInCompanyId: '', // Add if you have LinkedIn company page
  organizationSchema: {
    "@type": "Organization",
    "name": "Aquargin",
    "description": "Composable enterprise automation platform enabling no-code business solutions",
    "url": "https://aquargin.com",
    "logo": "https://aquargin.com/images/aquargin-logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91 70175 92307",
      "contactType": "customer service",
      "email": "support@aquargin.com"
    },
    "sameAs": [
      "https://www.youtube.com/@nocodeAquargin",
      "https://www.linkedin.com/company/aquargin",
      "https://twitter.com/aquargin"
    ]
  }
};
